import { statusInteraction} from './status-store'

let status;
statusInteraction.subscribe(prop => {
    status = prop
})
export const getAllStatus=(id)=>{
    return status
}
export const getStatus=(id)=>{
    return status[0][id]
}

export const setStatus=(id,value)=>{
    statusInteraction.update(prop => {
        prop[0][id]=value
        return prop
    })
    return status
}